import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

const ClipboardIcon = ({ size = 20, color = '#0D84FE', ...props }) => (
  <svg
    height={size}
    viewBox="0 0 20 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.905 0c-.418 0-.817.136-1.1.418-.163.163-.264.373-.333.597h-.597c-.366 0-.676.31-.676.676v.34H1.52C.688 2.03 0 2.717 0 3.552v10.486c0 .834.688 1.522 1.522 1.522H9.64c.835 0 1.523-.688 1.523-1.522V3.552c0-.835-.688-1.522-1.523-1.522h-.676v-.34c0-.365-.31-.675-.677-.675H7.69c-.07-.223-.17-.43-.333-.592C7.077.14 6.675 0 6.257 0H4.906zm1.353 1.015c.205 0 .31.05.38.12.07.07.127.182.127.387 0 .28.227.508.508.508h.676v1.014H3.212V2.03h.677c.135 0 .266-.055.36-.15.096-.098.15-.228.147-.363 0-.204.057-.31.127-.38s.176-.122.38-.122H6.26zm-4.736 2.03H2.2v.338c0 .366.31.676.675.676h5.412c.366 0 .677-.31.677-.677v-.34h.676c.29 0 .508.22.508.51v10.485c0 .29-.218.507-.508.507H1.522c-.29 0-.507-.217-.507-.507V3.552c0-.29.217-.508.507-.508zm14.658 3.12c.13 0 .26.048.36.147.198.198.198.52 0 .72l-.825.823h3.51c.28 0 .507.227.507.508 0 .28-.227.507-.508.507h-3.51l.826.824c.198.2.198.52 0 .72-.2.197-.512.196-.72 0l-1.67-1.67c-.104-.094-.17-.23-.17-.38 0-.152.066-.29.17-.382l1.67-1.67c.102-.1.23-.148.36-.148zm-13.36 0h3.757v.938H2.82v-.94zm0 1.878h5.637v.94H2.82v-.94zm0 1.88h4.697v.94H2.82v-.94z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

ClipboardIcon.propTypes = propTypes;

export default ClipboardIcon;
